import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LicenceStatusService } from 'src/app/services/licence-status/licence-status.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  isSuperAdmin: boolean = false;
  showLicenceBanner: boolean = false;
  userLicence$: Observable<any>;
  // Dans votre composant
  user = {
    firstName: '', // Remplacez par le prénom réel
    lastName: '',   // Remplacez par le nom réel
    profileColor: this.getRandomColor(),
    role: localStorage.getItem("UserROle")
  };

  constructor(private licenceStatusService: LicenceStatusService,
    private store: Store<any>) {
    this.userLicence$ = this.licenceStatusService.getUserLicence();
  }
  ngOnInit(): void {
    const userRole = localStorage.getItem("UserROle")!;
    const showGraceDaysBanner = localStorage.getItem("showGraceDaysBanner") === "true";
    this.isSuperAdmin = userRole === "SUPER_ADMIN";
    this.user = {
      ...this.user,
      lastName: localStorage.getItem("Nom")!,
      firstName: localStorage.getItem("Prenom")!,
      role: localStorage.getItem("UserROle")!
    }

    if (!this.isSuperAdmin) {
      this.showLicenceBanner = showGraceDaysBanner;
    }
  }

  // Méthode pour générer une couleur aléatoire
  getRandomColor() {
    const colors = [
      '#3B82F6', // blue-500
      '#EF4444', // red-500
      '#10B981', // emerald-500
      '#F59E0B', // amber-500
      '#8B5CF6', // violet-500
      '#EC4899', // pink-500
      '#14B8A6', // teal-500
      '#F97316'  // orange-500
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  }
}
